import { Tabs, Box } from '@wix/design-system';
import React, { useContext, useState, useMemo } from 'react';
import { RicosContext, ModalContext, PluginsEventsContext, UploadContext } from 'ricos-context';
import { MEDIA_POPOVERS_TABS_NAMES_BI } from 'wix-rich-content-common';
import { unreachable } from 'wix-rich-content-editor-common';
import { FullscreenMobileLayout, FloatingDesktopLayout } from 'wix-rich-content-ui-components';
import { c as classes, E as EmbedVideo } from '../embed-video-13f38899.js';
import { EMBED_TAB, UPLOAD_TAB, INSERT_PLUGIN_MODAL, INSERT_PLUGIN_MODAL_TABS } from '../dataHooks.js';
import { UploadVideo } from '../toolbar/upload-video.js';
import { VIDEO_TYPE } from '../types.js';
import 'react-player';
import 'ricos-content';
import '../style-inject.es-746bb8ed.js';
import '../toolbar/is-video-metadata.js';
import 'ricos-schema/dist/statics/video.defaults.json';
import 'wix-rich-content-plugin-commons';
import '../toolbar/videoPluginService.js';
import 'lodash';

const InsertModal = ({
  nodeId,
  modalId,
  componentData,
  handleFileSelection,
  handleFileUpload,
  enableCustomUploadOnMobile,
  onVideoSelected,
  disableDownloadDefault
}) => {
  var _a, _b;
  const { t, isMobile } = useContext(RicosContext);
  const modalService = useContext(ModalContext) || {};
  const pluginsEvents = useContext(PluginsEventsContext);
  const { uploadService, updateService } = useContext(UploadContext);
  const [activeTab, setActiveTab] = useState(
    ((_b = (_a = componentData == null ? void 0 : componentData.video) == null ? void 0 : _a.src) == null ? void 0 : _b.id) ? "upload" : "embed"
  );
  const items = useMemo(
    () => [
      { id: "embed", title: t("VideoModal_Tabs_Embed"), dataHook: EMBED_TAB },
      { id: "upload", title: t("VideoModal_Tabs_Upload"), dataHook: UPLOAD_TAB }
    ],
    [t]
  );
  const pluginEvents = {
    onPluginsPopOverTabSwitch: (data) => pluginsEvents.publishPluginPopoverTabSwitch(data),
    onPluginsPopOverClick: (data) => pluginsEvents.publishPluginPopoverClick(data),
    onVideoSelected
  };
  const closeModal = () => {
    modalService.closeModal(modalId);
  };
  const handleOnTabClick = (tab) => {
    var _a2;
    activeTab !== tab && ((_a2 = pluginEvents.onPluginsPopOverTabSwitch) == null ? void 0 : _a2.call(pluginEvents, {
      pluginId: VIDEO_TYPE,
      buttonName: getTabsBiButtonName(tab)
    }));
    setActiveTab(tab);
  };
  return /* @__PURE__ */ React.createElement(
    Layout,
    {
      t,
      isMobile,
      onCancel: closeModal,
      dataHook: INSERT_PLUGIN_MODAL,
      content: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        Tabs,
        {
          className: classes.tabs,
          hasDivider: true,
          minWidth: "100%",
          alignment: "center",
          type: "uniformFull",
          items,
          activeId: activeTab,
          onClick: (value) => handleOnTabClick(value.id),
          dataHook: INSERT_PLUGIN_MODAL_TABS
        }
      ), /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP4", padding: "SP4" }, (() => {
        switch (activeTab) {
          case "embed":
            return /* @__PURE__ */ React.createElement(
              EmbedVideo,
              {
                componentData,
                helpers: pluginEvents,
                closeModal
              }
            );
          case "upload":
            return /* @__PURE__ */ React.createElement(
              UploadVideo,
              {
                nodeId,
                helpers: pluginEvents,
                enableCustomUploadOnMobile,
                uploadService,
                updateService,
                closeModal,
                disableDownloadDefault,
                handleFileSelection,
                handleFileUpload
              }
            );
          default:
            unreachable(activeTab);
            return null;
        }
      })()))
    }
  );
};
const getTabsBiButtonName = (tab) => tab === "embed" ? MEDIA_POPOVERS_TABS_NAMES_BI.embed : MEDIA_POPOVERS_TABS_NAMES_BI.upload;
const Layout = ({ isMobile, content, onCancel, dataHook }) => {
  return isMobile ? /* @__PURE__ */ React.createElement(
    FullscreenMobileLayout,
    {
      content,
      title: "Video",
      onCancel,
      dataHook,
      hideFooter: true,
      noPadding: true
    }
  ) : /* @__PURE__ */ React.createElement(FloatingDesktopLayout, { onCancel, content, dataHook });
};

export { InsertModal };
//# sourceMappingURL=InsertModal.js.map
